import React from 'reactn';
import { Box, Typography, Button } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import FilterListIcon from '@material-ui/icons/FilterList';
import Datatable from 'material-table';
import moment from 'moment';
import SortIcon from '@material-ui/icons/Sort';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import BlockIcon from '@material-ui/icons/Block';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { isPermitted } from '../../../permission-control/permission-control';
import styles from './index.styles';
import { withStyles } from '@material-ui/styles';
import { setRelationshipData, RelationshipData, USER_CONTEXT } from '../../../../constants';
import { getRelationshipByUser, manageMessagingRelationship } from '../../../../util/APIUtils';
import LinkUser from '../../../link-user';
import Hoverable from '../../../hoverable';
import { UserIcon } from '../../../UserIcon';
import { withUnleash } from '../../../../v2/core/unleash';
import { UnleashService } from '../../../../v2/services';
import { theme } from '../../../../v2/core/containers/theme';
import { CustomTheme } from '@orijinworks/frontend-commons';

class Relationships extends React.Component {
  RELATIONSHIP_STATUS = {
    Active: 0,
    Deactive: 1,
  };
  relationshipColumns = [
    {
      title: 'Full Name',
      field: 'adminFullName',
      render: (rowData) => (
        <Hoverable title={rowData.adminFullName}>
          <Button style={{ textAlign: 'left' }} color="primary" onClick={() => this.onRedirect(rowData)}>
            {rowData.adminDisplayRoleName &&
              this.getIcon(
                this.global.cbacConfigFlag && rowData.adminRoleTypeNames
                  ? rowData.adminRoleTypeNames.split(',')
                  : rowData.adminDisplayRoleName
              )}{' '}
            &nbsp;
            {rowData.adminFullName}
          </Button>
        </Hoverable>
      ),
    },
    {
      title: 'Learner Assigned Location',
      field: 'learnerLocationName',
      render: (rowData) => <Hoverable title={rowData.learnerLocationName}>{rowData.learnerLocationName}</Hoverable>,
    },
    {
      title: 'Admin Assigned Location',
      field: 'adminLocationName',
      render: (rowData) => <Hoverable title={rowData.adminLocationName}>{rowData.adminLocationName}</Hoverable>,
    },
    {
      title: 'Admin Role',
      field: 'adminDisplayRoleName',
      render: (rowData) => <Hoverable title={rowData.adminDisplayRoleName}>{rowData.adminDisplayRoleName}</Hoverable>,
    },
    {
      title: 'Linked Date',
      field: 'createdDate',
      render: (rowData) => (
        <Hoverable title={moment.utc(rowData.createdDate).format('YYYY-MM-DD hh:mm a')}>
          {moment.utc(rowData.createdDate).format('YYYY-MM-DD hh:mm a')}
        </Hoverable>
      ),
    },
    {
      title: 'Status',
      field: 'relationshipStatus',
      lookup: { true: 'Active', false: 'Inactive' },
      render: (rowData) => {
        return (
          <Hoverable title={rowData.relationshipStatus}>
            <Typography
              style={{ color: rowData.relationshipStatus ? theme.palette.text.green : theme.palette.text.red }}
              component="p"
            >
              {rowData.relationshipStatus ? 'ACTIVE' : 'INACTIVE'}
            </Typography>
          </Hoverable>
        );
      },
    },
  ];
  state = {
    data: RelationshipData,
    filters: {
      searchTerm: '',
      location: '',
    },
    isLinkUserOpen: false,
  };

  componentDidMount() {
    if (!this.state.data) {
      this.getRelationshipByUser(this.props.profileUser.userId);
    }
  }

  /**
   * @name handleLinkUserDialog
   * @param {boolean} isOpen
   * @return {void}
   */
  handleLinkUserDialog = (isOpen) => {
    this.setState({
      isLinkUserOpen: isOpen,
    });
  };

  onRedirect = (rowData) => {
    const { unleashProps } = this.props;
    this.setGlobal({
      staffProfileID: rowData.adminPersonKey,
      staffSelectedLocation: rowData.adminLocationId,
      isStaffProfileOpen: unleashProps.isFlagEnabled() ? false : true,
      staffRole: rowData.adminDisplayRoleName,
      selectedUser: null,
      openProfileView: false,
    });
    if (unleashProps.isFlagEnabled()) {
      this.props.history.push(`/users/${rowData.adminPersonKey}?type=staff`);
    }
  };

  scaleIcon = () => {
    return (
      <svg
        xmlns="https://www.w3.org/2000/svg"
        xlink="https://www.w3.org/1999/xlink"
        svgjs="https://svgjs.com/svgjs"
        version="1.1"
        width="25px"
        height="25px"
        x="0"
        y="0"
        viewBox="0 0 480.004 480.004"
        space="preserve"
        class=""
      >
        <g>
          <g xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                d="M479.202,292.692l0.072-0.024l-78.808-171.952l19.112-9.512l-7.152-14.32l-18.632,9.28l-2.52-5.496    c-1.842-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.248,4.912c-13.56-6.298-28.329-9.566-43.28-9.576    h-67.2v-16h16v-16H266.25l5.752-23.016c4.416-17.673-6.33-35.58-24.003-39.997c-17.673-4.416-35.58,6.33-39.997,24.003    c-1.312,5.25-1.312,10.743,0,15.993l5.752,23.016h-13.752v16h16v16h-67.16c-14.966,0.012-29.75,3.288-43.32,9.6l-2.248-4.912    c-1.841-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.52,5.496l-18.632-9.32l-7.152,14.336    l19.112,9.552L0.73,292.668c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80    c30.913-0.035,55.965-25.087,56-56c-0.02-1.149-0.293-2.28-0.8-3.312l-79.024-172.6c11.487-5.332,24-8.092,36.664-8.088h67.16    v292.688l-27.312,27.312h-28.688c-22.08,0.026-39.974,17.92-40,40c0,4.418,3.582,8,8,8h224c4.418,0,8-3.582,8-8    c-0.026-22.08-17.92-39.974-40-40h-28.688l-27.312-27.312V112.004h67.2c12.664-0.004,25.177,2.756,36.664,8.088L288.73,292.668    c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80c30.913-0.035,55.965-25.087,56-56    C479.983,294.855,479.71,293.724,479.202,292.692z M136.002,336.004h-80c-19.002-0.021-35.375-13.387-39.2-32h158.4    C171.378,322.617,155.004,335.983,136.002,336.004z M171.538,288.004H20.466l73.488-160.328c1.342,0.36,2.754,0.36,4.096,0    L171.538,288.004z M226.618,22.532c6.23-7.392,17.273-8.333,24.665-2.103c0.759,0.64,1.463,1.344,2.103,2.103    c3.236,4.116,4.379,9.5,3.096,14.576l-6.728,26.896H230.25l-6.728-26.896C222.239,32.032,223.383,26.648,226.618,22.532z     M232.002,96.004v-16h16v16H232.002z M248.002,112.004v288h-16v-288H248.002z M320.002,448.004    c10.168,0.012,19.229,6.418,22.632,16H137.37c3.403-9.582,12.464-15.988,22.632-16H320.002z M268.69,432.004h-57.376l16-16h25.376    L268.69,432.004z M381.938,127.7c1.321,0.465,2.77,0.405,4.048-0.168l73.552,160.472H308.466L381.938,127.7z M424.002,336.004h-80    c-19.002-0.021-35.375-13.387-39.2-32h158.4C459.378,322.617,443.004,335.983,424.002,336.004z"
                fill={CustomTheme.palette.primary.main}
                data-original="#000000"
              />
            </g>
          </g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
          <g xmlns="http://www.w3.org/2000/svg"></g>
        </g>
      </svg>
    );
  };

  getIcon = (roleName) => {
    if (roleName === 'Attorney') {
      return this.scaleIcon();
    } else if (roleName === 'Learner') {
      return <UserIcon />;
    } else {
      return <VerifiedUserIcon />;
    }
  };

  /**
   * @name getContacts
   * @param {number} personID
   * @desc Fetch's contacts baseed upon personID.
   * @return {void}
   */
  getRelationshipByUser = (personID) => {
    this.setGlobal({
      isLoading: true,
    });
    this.setState({
      showEmptyDataSourceMessage: false,
    });
    getRelationshipByUser(personID).then(
      (_successLog) => {
        _successLog = this.processRelationshipsData(_successLog);
        this.setState({
          data: _successLog,
          showEmptyDataSourceMessage: true,
        });
        this.setGlobal({
          isLoading: false,
        });
        setRelationshipData(_successLog);
      },
      (_errorLog) => {
        this.setGlobal({
          isLoading: false,
        });
      }
    );
  };

  processRelationshipsData = (data) => {
    let relationships = data.filter((item, index, self) => {
      return (
        self.findIndex(
          (value) => value.learnerPersonKey === item.learnerPersonKey && value.adminPersonKey === item.adminPersonKey
        ) === index
      );
    });
    relationships = relationships.map((item) => {
      const filtered = data.filter(
        (value) => value.learnerPersonKey === item.learnerPersonKey && value.adminPersonKey === item.adminPersonKey
      );
      const roles = filtered.map((a) => a.adminDisplayRoleName);
      const locations = filtered.map((a) => a.adminLocationName);
      return {
        ...item,
        adminDisplayRoleName: [...new Set(roles)].join(', '),
        adminLocationName: [...new Set(locations)].join(', '),
      };
    });
    return relationships;
  };

  getFullName = (items, personId, keyName, returnKeyName) => {
    const item = items.find((data) => data[keyName] === personId);
    return item[returnKeyName];
  };

  /**
   * @name updateRelationshipStatus
   * @param {array} selectedItems
   * @param {boolean} isActive
   * @desc Updates relationship status to true / false respectively.
   * @return {void}
   */
  updateRelationshipStatus = (selectedItems, isActive) => {
    isActive = this.RELATIONSHIP_STATUS.Active === isActive;
    const requestPayload = {
      msgRelationships: selectedItems.map((selectedItem) => ({
        firstPersonKey: selectedItem.adminPersonKey,
        secondPersonKey: selectedItem.learnerPersonKey,
        status: isActive,
      })),
    };
    this.setGlobal({
      isLoading: true,
    });
    manageMessagingRelationship(requestPayload).then(
      (_successLog) => {
        this.setGlobal({
          isLoading: false,
        });
        const responseData = [];
        _successLog.successList.forEach((_successNodes) => {
          responseData.push({
            statusCode: _successNodes.statusCode,
            text: `Relationship between ${this.getFullName(
              selectedItems,
              _successNodes.firstPersonKey,
              'adminPersonKey',
              'adminFullName'
            )} and ${this.getFullName(
              selectedItems,
              _successNodes.secondPersonKey,
              'learnerPersonKey',
              'learnerFullName'
            )} ${isActive ? 'activated' : 'deactivated'}.`,
          });
        });
        _successLog.errorList.forEach((_errorNodes) => {
          responseData.push({
            statusCode: _errorNodes.statusCode,
            text: `${_errorNodes.statusMessage}.`,
          });
        });
        this.props.setResponse({
          isOpen: true,
          data: responseData,
          heading: 'Link Relationship',
        });
        this.getRelationshipByUser(this.props.profileUser.userId);
      },
      (_errorLog) => {
        this.setGlobal({
          isLoading: false,
        });
      }
    );
  };

  isButtonHidden = () => {
    const editPermission = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Edit_All_Relationships_At_Facility'
    );
    const personalPermission = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Create_Personal_Relationships'
    );

    return !editPermission && !personalPermission;
  };
  isCheckBoxHidden = (rowData) => {
    const loggedInUser = USER_CONTEXT || {};

    const personal = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Activate/Inactivate_Personal_Relationships'
    );
    const all = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Activate/Inactivate_All_Relationships_At_Facility'
    );

    if (personal && all) {
      return false;
    }
    if (all && !personal) {
      return false;
    }
    if (!all && personal) {
      const name1 = loggedInUser.personId;
      const name2 = rowData.adminPersonKey;
      return name1 !== name2;
    }
    return true;
  };
  allPermissionDenied = () => {
    const personal = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Activate/Inactivate_Personal_Relationships'
    );
    const all = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Activate/Inactivate_All_Relationships_At_Facility'
    );
    return !all && !personal;
  };
  areIconsHidden = () => {
    const all = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Activate/Inactivate_Personal_Relationships'
    );
    const personal = isPermitted(
      this.global.cbacConfigFlag,
      this.global.permissions,
      'Activate/Inactivate_All_Relationships_At_Facility'
    );
    return all || personal;
  };
  render() {
    return (
      <>
        <LinkUser
          isOpen={this.state.isLinkUserOpen}
          onClose={() => this.handleLinkUserDialog(false)}
          locations={this.props.userLocations}
          userInfo={{
            ...this.props.profileUser,
            displayName: `${this.props.profileUser.firstName} ${this.props.profileUser.lastName}`,
          }}
          getRelationships={() => this.getRelationshipByUser(this.props.profileUser.userId)}
        />
        <Box width="100%" display="flex" justifyContent="flex-end" marginBottom="15px">
          {!this.isButtonHidden() && (
            <Button onClick={() => this.handleLinkUserDialog(true)} variant="contained" color="primary" disableElevation>
              Create Relationship
            </Button>
          )}
        </Box>
        <Box width="100%" boxShadow={3}>
          <Datatable
            style={{ width: '100%' }}
            columns={this.relationshipColumns}
            data={this.state.data || []}
            localization={{
              header: {
                actions:
                  !isPermitted(
                    this.global.cbacConfigFlag,
                    this.global.permissions,
                    'Activate/Inactivate_Personal_Relationships'
                  ) ||
                  !isPermitted(
                    this.global.cbacConfigFlag,
                    this.global.permissions,
                    'Activate/Inactivate_All_Relationships_At_Facility'
                  )
                    ? ''
                    : 'Actions',
              },
            }}
            options={{
              showEmptyDataSourceMessage: this.state.showEmptyDataSourceMessage,
              sorting: true,
              pageSize: 20,
              selection: !this.allPermissionDenied(),
              showSelectAllCheckbox: isPermitted(
                this.global.cbacConfigFlag,
                this.global.permissions,
                'Activate/Inactivate_All_Relationships_At_Facility'
              ),
              filtering: true,
              exportAllData: true,
              exportButton: true,
              Sort: SortIcon,
              SortArrow: ArrowDownwardIcon,
              actionsColumnIndex: 0,
              search: false,
              exportFileName: 'Relationships',
              selectionProps: (rowData) => {
                return {
                  disabled: this.isCheckBoxHidden(rowData),
                  id: `checkbox-${rowData.formId}`,
                };
              },
            }}
            actions={[
              {
                icon: BeenhereIcon,
                tooltip: 'Activate',
                onClick: (event, selectedItems) =>
                  this.updateRelationshipStatus(selectedItems, this.RELATIONSHIP_STATUS.Active),
                hidden: !this.areIconsHidden(),
              },
              {
                icon: BlockIcon,
                tooltip: 'Deactivate',
                onClick: (event, selectedItems) =>
                  this.updateRelationshipStatus(selectedItems, this.RELATIONSHIP_STATUS.Deactive),
                hidden: !this.areIconsHidden(),
              },
            ]}
            icons={{
              Search: SearchIcon,
              ResetSearch: CloseIcon,
              FirstPage: FirstPageIcon,
              LastPage: LastPageIcon,
              NextPage: NavigateNextIcon,
              PreviousPage: NavigateBeforeIcon,
              Filter: FilterListIcon,
              SortArrow: ArrowUpwardIcon,
              Export: SaveAltIcon,
              Edit: EditIcon,
              User: UserIcon,
            }}
            title={'Relationships'}
          />
        </Box>
      </>
    );
  }
}

export default withStyles(styles)(withUnleash(Relationships, UnleashService.FLAGS.STAFF_PROFILE_UI_PAGE));
